module.exports = __webpack_public_path__ + "static/Web-brief-2ec95b62db81945e44aa8b01dd555010.pdf";